import { isPastDate, isPastDateTime } from '../utils';

export const useDateTimeHandlers = (
  displayPeriod: Date,
  setDisplayPeriod: (date: Date) => void
) => {
  const handleDateChange = (dateString: string) => {
    // 過去の日付が選択された場合は処理を中断
    if (isPastDate(dateString)) {
      return;
    }
    
    const newDate = new Date(displayPeriod);
    const [year, month, day] = dateString.split('-').map(Number);
    newDate.setFullYear(year, month - 1, day);
    
    // 今日の日付で過去の時刻が選択されている場合は現在時刻+1時間に調整
    if (isPastDateTime(newDate)) {
      const now = new Date();
      now.setHours(now.getHours() + 1, 0, 0, 0);
      setDisplayPeriod(now);
    } else {
      setDisplayPeriod(newDate);
    }
  };

  const handleTimeChange = (timeString: string) => {
    const newDate = new Date(displayPeriod);
    const [hour, minute] = timeString.split(':').map(Number);
    newDate.setHours(hour, minute);
    
    // 過去の時刻が選択された場合は処理を中断
    if (isPastDateTime(newDate)) {
      return;
    }
    
    setDisplayPeriod(newDate);
  };

  return {
    handleDateChange,
    handleTimeChange
  };
}; 